import { z } from "zod";

const localeEnum = z.enum(["en", "no", "se", "dk"]);

export type Locale = z.infer<typeof localeEnum>;

export const supportedLocales: Set<Locale> = new Set(["en", "no", "se", "dk"]);
